import { useState, useCallback, useEffect } from 'react'
import taskService from '../services/tasks/taskService'
import { showSuccessToast } from '../helpers/toast'

export default function useDocs(membertaskId) {
  const [docs, setDocs] = useState([])
  const [loading, setLoading] = useState(false)
  const [uploading, setUploading] = useState(false)

  const fetchDocs = useCallback(async () => {
    if (!membertaskId) return
    setLoading(true)
    try {
      const response = await taskService.getDocs(membertaskId)
      setDocs(response.data.results || response.data)
    } catch {
      setDocs([])
    } finally {
      setLoading(false)
    }
  }, [membertaskId])

  useEffect(() => {
    fetchDocs()
  }, [fetchDocs])

  const addDoc = useCallback(async (file, description) => {
    setUploading(true)
    try {
      await taskService.addDoc(membertaskId, file, description)
      showSuccessToast('Dokumenti u ngarkua.')
      await fetchDocs()
    } finally {
      setUploading(false)
    }
  }, [membertaskId, fetchDocs])

  const deleteDoc = useCallback(async (id) => {
    try {
      await taskService.deleteDoc(id)
      showSuccessToast('Dokumenti u fshi.')
      await fetchDocs()
    } catch {
      // error handled by interceptor
    }
  }, [fetchDocs])

  return {
    docs,
    loading,
    uploading,
    addDoc,
    deleteDoc,
    refresh: fetchDocs,
  }
}
